// extracted by mini-css-extract-plugin
export var accountButton = "account-widget-module--account-button--a200c";
export var authLinks = "account-widget-module--auth-links--d5766";
export var authMobile = "account-widget-module--auth-mobile--b18a1";
export var authMobileContainer = "account-widget-module--auth-mobile-container--b968e";
export var authMobileLinks = "account-widget-module--auth-mobile-links--b30d7";
export var authMobileLogo = "account-widget-module--auth-mobile-logo--70d9b";
export var avatarBox = "account-widget-module--avatar-box--5630a";
export var chevron = "account-widget-module--chevron--af999";
export var closed = "account-widget-module--closed--bde0e";
export var desktopContainer = "account-widget-module--desktop-container--19ab6";
export var desktopNavButton = "account-widget-module--desktop-nav-button--6e291";
export var desktopNavItem = "account-widget-module--desktop-nav-item--c843c";
export var desktopNavLink = "account-widget-module--desktop-nav-link--5bdfe";
export var desktopNavList = "account-widget-module--desktop-nav-list--7406b";
export var dropdownContainer = "account-widget-module--dropdown-container--e3282";
export var level1 = "account-widget-module--level1--c13fe";
export var linkActive = "account-widget-module--link-active--f3b1c";
export var linkPartiallyActive = "account-widget-module--link-partially-active--f7be4";
export var mobileContainer = "account-widget-module--mobile-container--801e6";
export var mobileLogoutBox = "account-widget-module--mobile-logout-box--36996";
export var mobileLogoutButton = "account-widget-module--mobile-logout-button--26992";
export var mobileNav = "account-widget-module--mobile-nav--e7eb5";
export var mobileNavButton = "account-widget-module--mobile-nav-button--eb699";
export var mobileNavItem = "account-widget-module--mobile-nav-item--20c7b";
export var mobileNavLink = "account-widget-module--mobile-nav-link--a1a7c";
export var mobileNavList = "account-widget-module--mobile-nav-list--21b7d";
export var mobilePanelBottom = "account-widget-module--mobile-panel-bottom--a37f5";
export var mobilePanelContainer = "account-widget-module--mobile-panel-container--2448d";
export var mobileSwitchProfileButton = "account-widget-module--mobile-switch-profile-button--ae56d";
export var mobileSwitchProfileRow = "account-widget-module--mobile-switch-profile-row--2e086";
export var msgCounter = "account-widget-module--msg-counter--13841";
export var name = "account-widget-module--name--e9794";
export var separator = "account-widget-module--separator--6d309";